/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * Jisr CRM API specification
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Agent,
  AgentInput,
  AgentLoad,
  AgentPerformance,
  AgentStatusUpdate,
  AgentUpdate,
  AssignInput,
  Conversation,
  ConversationInput,
  ConversationUpdate,
  Customer,
  CustomerInput,
  CustomerUpdate,
  DailyVolume,
  DashboardStats,
  GetAgentPerformanceParams,
  GetConversationVolumeParams,
  GetDashboardStatsParams,
  HealthStatus,
  ListConversationsParams,
  ListCustomersParams,
  ListMediaParams,
  ListNotificationsParams,
  ListTemplatesParams,
  MarkAllNotificationsRead200,
  MarkAllReadInput,
  MarkReadInput,
  MediaInput,
  MediaItem,
  Message,
  MessageInput,
  Notification,
  ReportRequest,
  ReportResult,
  RoutingConfig,
  RoutingConfigUpdate,
  TagCount,
  Template,
  TemplateInput,
  TemplateUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAgentsUrl = () => {




  return `/api/agents`
}

/**
 * @summary List all agents
 */
export const listAgents = async ( options?: RequestInit): Promise<Agent[]> => {

  return customFetch<Agent[]>(getListAgentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgentsQueryKey = () => {
    return [
    `/api/agents`
    ] as const;
    }


export const getListAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listAgents>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgents>>> = ({ signal }) => listAgents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgents>>>
export type ListAgentsQueryError = ErrorType<unknown>


/**
 * @summary List all agents
 */

export function useListAgents<TData = Awaited<ReturnType<typeof listAgents>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAgents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAgentsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAgentUrl = () => {




  return `/api/agents`
}

/**
 * @summary Create a new agent
 */
export const createAgent = async (agentInput: AgentInput, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getCreateAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentInput,)
  }
);}




export const getCreateAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext> => {

const mutationKey = ['createAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgent>>, {data: BodyType<AgentInput>}> = (props) => {
          const {data} = props ?? {};

          return  createAgent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgentMutationResult = NonNullable<Awaited<ReturnType<typeof createAgent>>>
    export type CreateAgentMutationBody = BodyType<AgentInput>
    export type CreateAgentMutationError = ErrorType<unknown>

    /**
 * @summary Create a new agent
 */
export const useCreateAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgent>>, TError,{data: BodyType<AgentInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgent>>,
        TError,
        {data: BodyType<AgentInput>},
        TContext
      > => {
      return useMutation(getCreateAgentMutationOptions(options));
    }

export const getGetAgentUrl = (id: number,) => {




  return `/api/agents/${id}`
}

export const getAgent = async (id: number, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getGetAgentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentQueryKey = (id: number,) => {
    return [
    `/api/agents/${id}`
    ] as const;
    }


export const getGetAgentQueryOptions = <TData = Awaited<ReturnType<typeof getAgent>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgent>>> = ({ signal }) => getAgent(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentQueryResult = NonNullable<Awaited<ReturnType<typeof getAgent>>>
export type GetAgentQueryError = ErrorType<void>



export function useGetAgent<TData = Awaited<ReturnType<typeof getAgent>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgent>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateAgentUrl = (id: number,) => {




  return `/api/agents/${id}`
}

export const updateAgent = async (id: number,
    agentUpdate: AgentUpdate, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getUpdateAgentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentUpdate,)
  }
);}




export const getUpdateAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext> => {

const mutationKey = ['updateAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgent>>, {id: number;data: BodyType<AgentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAgent(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgent>>>
    export type UpdateAgentMutationBody = BodyType<AgentUpdate>
    export type UpdateAgentMutationError = ErrorType<unknown>

    export const useUpdateAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgent>>, TError,{id: number;data: BodyType<AgentUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgent>>,
        TError,
        {id: number;data: BodyType<AgentUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAgentMutationOptions(options));
    }

export const getDeleteAgentUrl = (id: number,) => {




  return `/api/agents/${id}`
}

export const deleteAgent = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAgentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAgent>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAgent>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteAgent(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAgent>>>

    export type DeleteAgentMutationError = ErrorType<unknown>

    export const useDeleteAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAgent>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAgent>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteAgentMutationOptions(options));
    }

export const getUpdateAgentStatusUrl = (id: number,) => {




  return `/api/agents/${id}/status`
}

export const updateAgentStatus = async (id: number,
    agentStatusUpdate: AgentStatusUpdate, options?: RequestInit): Promise<Agent> => {

  return customFetch<Agent>(getUpdateAgentStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agentStatusUpdate,)
  }
);}




export const getUpdateAgentStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentStatus>>, TError,{id: number;data: BodyType<AgentStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgentStatus>>, TError,{id: number;data: BodyType<AgentStatusUpdate>}, TContext> => {

const mutationKey = ['updateAgentStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgentStatus>>, {id: number;data: BodyType<AgentStatusUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateAgentStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgentStatus>>>
    export type UpdateAgentStatusMutationBody = BodyType<AgentStatusUpdate>
    export type UpdateAgentStatusMutationError = ErrorType<unknown>

    export const useUpdateAgentStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentStatus>>, TError,{id: number;data: BodyType<AgentStatusUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAgentStatus>>,
        TError,
        {id: number;data: BodyType<AgentStatusUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAgentStatusMutationOptions(options));
    }

export const getListCustomersUrl = (params?: ListCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers?${stringifiedParams}` : `/api/customers`
}

export const listCustomers = async (params?: ListCustomersParams, options?: RequestInit): Promise<Customer[]> => {

  return customFetch<Customer[]>(getListCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomersQueryKey = (params?: ListCustomersParams,) => {
    return [
    `/api/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({ signal }) => listCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomers>>>
export type ListCustomersQueryError = ErrorType<unknown>



export function useListCustomers<TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(
 params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCustomerUrl = () => {




  return `/api/customers`
}

export const createCustomer = async (customerInput: CustomerInput, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerInput,)
  }
);}




export const getCreateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: BodyType<CustomerInput>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = BodyType<CustomerInput>
    export type CreateCustomerMutationError = ErrorType<unknown>

    export const useCreateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CustomerInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: BodyType<CustomerInput>},
        TContext
      > => {
      return useMutation(getCreateCustomerMutationOptions(options));
    }

export const getGetCustomerUrl = (id: number,) => {




  return `/api/customers/${id}`
}

export const getCustomer = async (id: number, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getGetCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerQueryKey = (id: number,) => {
    return [
    `/api/customers/${id}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = ErrorType<unknown>



export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCustomerUrl = (id: number,) => {




  return `/api/customers/${id}`
}

export const updateCustomer = async (id: number,
    customerUpdate: CustomerUpdate, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getUpdateCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerUpdate,)
  }
);}




export const getUpdateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerUpdate>}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: number;data: BodyType<CustomerUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = BodyType<CustomerUpdate>
    export type UpdateCustomerMutationError = ErrorType<unknown>

    export const useUpdateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CustomerUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: number;data: BodyType<CustomerUpdate>},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options));
    }

export const getListConversationsUrl = (params?: ListConversationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/conversations?${stringifiedParams}` : `/api/conversations`
}

export const listConversations = async (params?: ListConversationsParams, options?: RequestInit): Promise<Conversation[]> => {

  return customFetch<Conversation[]>(getListConversationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConversationsQueryKey = (params?: ListConversationsParams,) => {
    return [
    `/api/conversations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConversationsQueryOptions = <TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<unknown>>(params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConversationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConversations>>> = ({ signal }) => listConversations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListConversationsQueryResult = NonNullable<Awaited<ReturnType<typeof listConversations>>>
export type ListConversationsQueryError = ErrorType<unknown>



export function useListConversations<TData = Awaited<ReturnType<typeof listConversations>>, TError = ErrorType<unknown>>(
 params?: ListConversationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listConversations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListConversationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateConversationUrl = () => {




  return `/api/conversations`
}

export const createConversation = async (conversationInput: ConversationInput, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getCreateConversationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      conversationInput,)
  }
);}




export const getCreateConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: BodyType<ConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: BodyType<ConversationInput>}, TContext> => {

const mutationKey = ['createConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConversation>>, {data: BodyType<ConversationInput>}> = (props) => {
          const {data} = props ?? {};

          return  createConversation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof createConversation>>>
    export type CreateConversationMutationBody = BodyType<ConversationInput>
    export type CreateConversationMutationError = ErrorType<unknown>

    export const useCreateConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConversation>>, TError,{data: BodyType<ConversationInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createConversation>>,
        TError,
        {data: BodyType<ConversationInput>},
        TContext
      > => {
      return useMutation(getCreateConversationMutationOptions(options));
    }

export const getGetConversationUrl = (id: number,) => {




  return `/api/conversations/${id}`
}

export const getConversation = async (id: number, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getGetConversationUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationQueryKey = (id: number,) => {
    return [
    `/api/conversations/${id}`
    ] as const;
    }


export const getGetConversationQueryOptions = <TData = Awaited<ReturnType<typeof getConversation>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({ signal }) => getConversation(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationQueryResult = NonNullable<Awaited<ReturnType<typeof getConversation>>>
export type GetConversationQueryError = ErrorType<unknown>



export function useGetConversation<TData = Awaited<ReturnType<typeof getConversation>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateConversationUrl = (id: number,) => {




  return `/api/conversations/${id}`
}

export const updateConversation = async (id: number,
    conversationUpdate: ConversationUpdate, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getUpdateConversationUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      conversationUpdate,)
  }
);}




export const getUpdateConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{id: number;data: BodyType<ConversationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{id: number;data: BodyType<ConversationUpdate>}, TContext> => {

const mutationKey = ['updateConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConversation>>, {id: number;data: BodyType<ConversationUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateConversation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConversationMutationResult = NonNullable<Awaited<ReturnType<typeof updateConversation>>>
    export type UpdateConversationMutationBody = BodyType<ConversationUpdate>
    export type UpdateConversationMutationError = ErrorType<unknown>

    export const useUpdateConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConversation>>, TError,{id: number;data: BodyType<ConversationUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateConversation>>,
        TError,
        {id: number;data: BodyType<ConversationUpdate>},
        TContext
      > => {
      return useMutation(getUpdateConversationMutationOptions(options));
    }

export const getDeleteConversationUrl = (id: number,) => {




  return `/api/conversations/${id}`
}

export const deleteConversation = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteConversationUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConversationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConversation>>>

    export type DeleteConversationMutationError = ErrorType<unknown>

    export const useDeleteConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteConversationMutationOptions(options));
    }

export const getAssignConversationUrl = (id: number,) => {




  return `/api/conversations/${id}/assign`
}

export const assignConversation = async (id: number,
    assignInput: AssignInput, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getAssignConversationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assignInput,)
  }
);}




export const getAssignConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignConversation>>, TError,{id: number;data: BodyType<AssignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignConversation>>, TError,{id: number;data: BodyType<AssignInput>}, TContext> => {

const mutationKey = ['assignConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignConversation>>, {id: number;data: BodyType<AssignInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  assignConversation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignConversationMutationResult = NonNullable<Awaited<ReturnType<typeof assignConversation>>>
    export type AssignConversationMutationBody = BodyType<AssignInput>
    export type AssignConversationMutationError = ErrorType<unknown>

    export const useAssignConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignConversation>>, TError,{id: number;data: BodyType<AssignInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignConversation>>,
        TError,
        {id: number;data: BodyType<AssignInput>},
        TContext
      > => {
      return useMutation(getAssignConversationMutationOptions(options));
    }

export const getCloseConversationUrl = (id: number,) => {




  return `/api/conversations/${id}/close`
}

export const closeConversation = async (id: number, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getCloseConversationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCloseConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof closeConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['closeConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  closeConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseConversationMutationResult = NonNullable<Awaited<ReturnType<typeof closeConversation>>>

    export type CloseConversationMutationError = ErrorType<unknown>

    export const useCloseConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof closeConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCloseConversationMutationOptions(options));
    }

export const getReopenConversationUrl = (id: number,) => {




  return `/api/conversations/${id}/reopen`
}

export const reopenConversation = async (id: number, options?: RequestInit): Promise<Conversation> => {

  return customFetch<Conversation>(getReopenConversationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReopenConversationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenConversation>>, TError,{id: number}, TContext> => {

const mutationKey = ['reopenConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenConversation>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  reopenConversation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenConversationMutationResult = NonNullable<Awaited<ReturnType<typeof reopenConversation>>>

    export type ReopenConversationMutationError = ErrorType<unknown>

    export const useReopenConversation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenConversation>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reopenConversation>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getReopenConversationMutationOptions(options));
    }

export const getListMessagesUrl = (conversationId: number,) => {




  return `/api/conversations/${conversationId}/messages`
}

export const listMessages = async (conversationId: number, options?: RequestInit): Promise<Message[]> => {

  return customFetch<Message[]>(getListMessagesUrl(conversationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMessagesQueryKey = (conversationId: number,) => {
    return [
    `/api/conversations/${conversationId}/messages`
    ] as const;
    }


export const getListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<unknown>>(conversationId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMessagesQueryKey(conversationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMessages>>> = ({ signal }) => listMessages(conversationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(conversationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listMessages>>>
export type ListMessagesQueryError = ErrorType<unknown>



export function useListMessages<TData = Awaited<ReturnType<typeof listMessages>>, TError = ErrorType<unknown>>(
 conversationId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMessages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMessagesQueryOptions(conversationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getSendMessageUrl = (conversationId: number,) => {




  return `/api/conversations/${conversationId}/messages`
}

export const sendMessage = async (conversationId: number,
    messageInput: MessageInput, options?: RequestInit): Promise<Message> => {

  return customFetch<Message>(getSendMessageUrl(conversationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      messageInput,)
  }
);}




export const getSendMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<MessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<MessageInput>}, TContext> => {

const mutationKey = ['sendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMessage>>, {conversationId: number;data: BodyType<MessageInput>}> = (props) => {
          const {conversationId,data} = props ?? {};

          return  sendMessage(conversationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendMessage>>>
    export type SendMessageMutationBody = BodyType<MessageInput>
    export type SendMessageMutationError = ErrorType<unknown>

    export const useSendMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMessage>>, TError,{conversationId: number;data: BodyType<MessageInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendMessage>>,
        TError,
        {conversationId: number;data: BodyType<MessageInput>},
        TContext
      > => {
      return useMutation(getSendMessageMutationOptions(options));
    }

export const getMarkMessageReadUrl = (conversationId: number,
    messageId: number,) => {




  return `/api/conversations/${conversationId}/messages/${messageId}/read`
}

export const markMessageRead = async (conversationId: number,
    messageId: number,
    markReadInput: MarkReadInput, options?: RequestInit): Promise<Message> => {

  return customFetch<Message>(getMarkMessageReadUrl(conversationId,messageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markReadInput,)
  }
);}




export const getMarkMessageReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{conversationId: number;messageId: number;data: BodyType<MarkReadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{conversationId: number;messageId: number;data: BodyType<MarkReadInput>}, TContext> => {

const mutationKey = ['markMessageRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markMessageRead>>, {conversationId: number;messageId: number;data: BodyType<MarkReadInput>}> = (props) => {
          const {conversationId,messageId,data} = props ?? {};

          return  markMessageRead(conversationId,messageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkMessageReadMutationResult = NonNullable<Awaited<ReturnType<typeof markMessageRead>>>
    export type MarkMessageReadMutationBody = BodyType<MarkReadInput>
    export type MarkMessageReadMutationError = ErrorType<unknown>

    export const useMarkMessageRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markMessageRead>>, TError,{conversationId: number;messageId: number;data: BodyType<MarkReadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markMessageRead>>,
        TError,
        {conversationId: number;messageId: number;data: BodyType<MarkReadInput>},
        TContext
      > => {
      return useMutation(getMarkMessageReadMutationOptions(options));
    }

export const getListTemplatesUrl = (params?: ListTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/templates?${stringifiedParams}` : `/api/templates`
}

export const listTemplates = async (params?: ListTemplatesParams, options?: RequestInit): Promise<Template[]> => {

  return customFetch<Template[]>(getListTemplatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplatesQueryKey = (params?: ListTemplatesParams,) => {
    return [
    `/api/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<unknown>>(params?: ListTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = ErrorType<unknown>



export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<unknown>>(
 params?: ListTemplatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTemplateUrl = () => {




  return `/api/templates`
}

export const createTemplate = async (templateInput: TemplateInput, options?: RequestInit): Promise<Template> => {

  return customFetch<Template>(getCreateTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateInput,)
  }
);}




export const getCreateTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: BodyType<TemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: BodyType<TemplateInput>}, TContext> => {

const mutationKey = ['createTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplate>>, {data: BodyType<TemplateInput>}> = (props) => {
          const {data} = props ?? {};

          return  createTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplate>>>
    export type CreateTemplateMutationBody = BodyType<TemplateInput>
    export type CreateTemplateMutationError = ErrorType<unknown>

    export const useCreateTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplate>>, TError,{data: BodyType<TemplateInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTemplate>>,
        TError,
        {data: BodyType<TemplateInput>},
        TContext
      > => {
      return useMutation(getCreateTemplateMutationOptions(options));
    }

export const getUpdateTemplateUrl = (id: number,) => {




  return `/api/templates/${id}`
}

export const updateTemplate = async (id: number,
    templateUpdate: TemplateUpdate, options?: RequestInit): Promise<Template> => {

  return customFetch<Template>(getUpdateTemplateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      templateUpdate,)
  }
);}




export const getUpdateTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: number;data: BodyType<TemplateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: number;data: BodyType<TemplateUpdate>}, TContext> => {

const mutationKey = ['updateTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplate>>, {id: number;data: BodyType<TemplateUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTemplate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplate>>>
    export type UpdateTemplateMutationBody = BodyType<TemplateUpdate>
    export type UpdateTemplateMutationError = ErrorType<unknown>

    export const useUpdateTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,{id: number;data: BodyType<TemplateUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplate>>,
        TError,
        {id: number;data: BodyType<TemplateUpdate>},
        TContext
      > => {
      return useMutation(getUpdateTemplateMutationOptions(options));
    }

export const getDeleteTemplateUrl = (id: number,) => {




  return `/api/templates/${id}`
}

export const deleteTemplate = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTemplateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>

    export type DeleteTemplateMutationError = ErrorType<unknown>

    export const useDeleteTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTemplateMutationOptions(options));
    }

export const getUseTemplateUrl = (id: number,) => {




  return `/api/templates/${id}/use`
}

export const useTemplate = async (id: number, options?: RequestInit): Promise<Template> => {

  return customFetch<Template>(getUseTemplateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUseTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof useTemplate>>, TError,{id: number}, TContext> => {

const mutationKey = ['useTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof useTemplate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  useTemplate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UseTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof useTemplate>>>

    export type UseTemplateMutationError = ErrorType<unknown>

    export const useUseTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useTemplate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof useTemplate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUseTemplateMutationOptions(options));
    }

export const getListMediaUrl = (params?: ListMediaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/media?${stringifiedParams}` : `/api/media`
}

export const listMedia = async (params?: ListMediaParams, options?: RequestInit): Promise<MediaItem[]> => {

  return customFetch<MediaItem[]>(getListMediaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMediaQueryKey = (params?: ListMediaParams,) => {
    return [
    `/api/media`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMediaQueryOptions = <TData = Awaited<ReturnType<typeof listMedia>>, TError = ErrorType<unknown>>(params?: ListMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMediaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMedia>>> = ({ signal }) => listMedia(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMedia>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMediaQueryResult = NonNullable<Awaited<ReturnType<typeof listMedia>>>
export type ListMediaQueryError = ErrorType<unknown>



export function useListMedia<TData = Awaited<ReturnType<typeof listMedia>>, TError = ErrorType<unknown>>(
 params?: ListMediaParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMedia>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMediaQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateMediaUrl = () => {




  return `/api/media`
}

export const createMedia = async (mediaInput: MediaInput, options?: RequestInit): Promise<MediaItem> => {

  return customFetch<MediaItem>(getCreateMediaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mediaInput,)
  }
);}




export const getCreateMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMedia>>, TError,{data: BodyType<MediaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMedia>>, TError,{data: BodyType<MediaInput>}, TContext> => {

const mutationKey = ['createMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMedia>>, {data: BodyType<MediaInput>}> = (props) => {
          const {data} = props ?? {};

          return  createMedia(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMediaMutationResult = NonNullable<Awaited<ReturnType<typeof createMedia>>>
    export type CreateMediaMutationBody = BodyType<MediaInput>
    export type CreateMediaMutationError = ErrorType<unknown>

    export const useCreateMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMedia>>, TError,{data: BodyType<MediaInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMedia>>,
        TError,
        {data: BodyType<MediaInput>},
        TContext
      > => {
      return useMutation(getCreateMediaMutationOptions(options));
    }

export const getDeleteMediaUrl = (id: number,) => {




  return `/api/media/${id}`
}

export const deleteMedia = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteMediaUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMedia>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMedia>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMedia>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteMedia(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMediaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMedia>>>

    export type DeleteMediaMutationError = ErrorType<unknown>

    export const useDeleteMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMedia>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMedia>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteMediaMutationOptions(options));
    }

export const getUseMediaUrl = (id: number,) => {




  return `/api/media/${id}/use`
}

export const useMedia = async (id: number, options?: RequestInit): Promise<MediaItem> => {

  return customFetch<MediaItem>(getUseMediaUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUseMediaMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useMedia>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof useMedia>>, TError,{id: number}, TContext> => {

const mutationKey = ['useMedia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof useMedia>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  useMedia(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UseMediaMutationResult = NonNullable<Awaited<ReturnType<typeof useMedia>>>

    export type UseMediaMutationError = ErrorType<unknown>

    export const useUseMedia = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useMedia>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof useMedia>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getUseMediaMutationOptions(options));
    }

export const getListNotificationsUrl = (params: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/notifications?${stringifiedParams}` : `/api/notifications`
}

export const listNotifications = async (params: ListNotificationsParams, options?: RequestInit): Promise<Notification[]> => {

  return customFetch<Notification[]>(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListNotificationsQueryKey = (params?: ListNotificationsParams,) => {
    return [
    `/api/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getListNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(params: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) => listNotifications(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>
export type ListNotificationsQueryError = ErrorType<unknown>



export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ErrorType<unknown>>(
 params: ListNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMarkNotificationReadUrl = (id: number,) => {




  return `/api/notifications/${id}/read`
}

export const markNotificationRead = async (id: number, options?: RequestInit): Promise<Notification> => {

  return customFetch<Notification>(getMarkNotificationReadUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getMarkNotificationReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext> => {

const mutationKey = ['markNotificationRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  markNotificationRead(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>

    export type MarkNotificationReadMutationError = ErrorType<unknown>

    export const useMarkNotificationRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationRead>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getMarkNotificationReadMutationOptions(options));
    }

export const getMarkAllNotificationsReadUrl = () => {




  return `/api/notifications/read-all`
}

export const markAllNotificationsRead = async (markAllReadInput: MarkAllReadInput, options?: RequestInit): Promise<MarkAllNotificationsRead200> => {

  return customFetch<MarkAllNotificationsRead200>(getMarkAllNotificationsReadUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markAllReadInput,)
  }
);}




export const getMarkAllNotificationsReadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{data: BodyType<MarkAllReadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{data: BodyType<MarkAllReadInput>}, TContext> => {

const mutationKey = ['markAllNotificationsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, {data: BodyType<MarkAllReadInput>}> = (props) => {
          const {data} = props ?? {};

          return  markAllNotificationsRead(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>
    export type MarkAllNotificationsReadMutationBody = BodyType<MarkAllReadInput>
    export type MarkAllNotificationsReadMutationError = ErrorType<unknown>

    export const useMarkAllNotificationsRead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError,{data: BodyType<MarkAllReadInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsRead>>,
        TError,
        {data: BodyType<MarkAllReadInput>},
        TContext
      > => {
      return useMutation(getMarkAllNotificationsReadMutationOptions(options));
    }

export const getGetDashboardStatsUrl = (params?: GetDashboardStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/stats?${stringifiedParams}` : `/api/dashboard/stats`
}

export const getDashboardStats = async (params?: GetDashboardStatsParams, options?: RequestInit): Promise<DashboardStats> => {

  return customFetch<DashboardStats>(getGetDashboardStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardStatsQueryKey = (params?: GetDashboardStatsParams,) => {
    return [
    `/api/dashboard/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>(params?: GetDashboardStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStats>>> = ({ signal }) => getDashboardStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStats>>>
export type GetDashboardStatsQueryError = ErrorType<unknown>



export function useGetDashboardStats<TData = Awaited<ReturnType<typeof getDashboardStats>>, TError = ErrorType<unknown>>(
 params?: GetDashboardStatsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardStatsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAgentPerformanceUrl = (params?: GetAgentPerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/agent-performance?${stringifiedParams}` : `/api/dashboard/agent-performance`
}

export const getAgentPerformance = async (params?: GetAgentPerformanceParams, options?: RequestInit): Promise<AgentPerformance[]> => {

  return customFetch<AgentPerformance[]>(getGetAgentPerformanceUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentPerformanceQueryKey = (params?: GetAgentPerformanceParams,) => {
    return [
    `/api/dashboard/agent-performance`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgentPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getAgentPerformance>>, TError = ErrorType<unknown>>(params?: GetAgentPerformanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentPerformanceQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentPerformance>>> = ({ signal }) => getAgentPerformance(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentPerformance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentPerformance>>>
export type GetAgentPerformanceQueryError = ErrorType<unknown>



export function useGetAgentPerformance<TData = Awaited<ReturnType<typeof getAgentPerformance>>, TError = ErrorType<unknown>>(
 params?: GetAgentPerformanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentPerformance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentPerformanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetConversationVolumeUrl = (params?: GetConversationVolumeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/conversation-volume?${stringifiedParams}` : `/api/dashboard/conversation-volume`
}

export const getConversationVolume = async (params?: GetConversationVolumeParams, options?: RequestInit): Promise<DailyVolume[]> => {

  return customFetch<DailyVolume[]>(getGetConversationVolumeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConversationVolumeQueryKey = (params?: GetConversationVolumeParams,) => {
    return [
    `/api/dashboard/conversation-volume`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConversationVolumeQueryOptions = <TData = Awaited<ReturnType<typeof getConversationVolume>>, TError = ErrorType<unknown>>(params?: GetConversationVolumeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversationVolume>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConversationVolumeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversationVolume>>> = ({ signal }) => getConversationVolume(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConversationVolume>>, TError, TData> & { queryKey: QueryKey }
}

export type GetConversationVolumeQueryResult = NonNullable<Awaited<ReturnType<typeof getConversationVolume>>>
export type GetConversationVolumeQueryError = ErrorType<unknown>



export function useGetConversationVolume<TData = Awaited<ReturnType<typeof getConversationVolume>>, TError = ErrorType<unknown>>(
 params?: GetConversationVolumeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getConversationVolume>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetConversationVolumeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetTagDistributionUrl = () => {




  return `/api/dashboard/tag-distribution`
}

export const getTagDistribution = async ( options?: RequestInit): Promise<TagCount[]> => {

  return customFetch<TagCount[]>(getGetTagDistributionUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTagDistributionQueryKey = () => {
    return [
    `/api/dashboard/tag-distribution`
    ] as const;
    }


export const getGetTagDistributionQueryOptions = <TData = Awaited<ReturnType<typeof getTagDistribution>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagDistribution>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagDistributionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagDistribution>>> = ({ signal }) => getTagDistribution({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagDistribution>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagDistributionQueryResult = NonNullable<Awaited<ReturnType<typeof getTagDistribution>>>
export type GetTagDistributionQueryError = ErrorType<unknown>



export function useGetTagDistribution<TData = Awaited<ReturnType<typeof getTagDistribution>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagDistribution>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTagDistributionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetAgentLoadUrl = () => {




  return `/api/dashboard/agent-load`
}

export const getAgentLoad = async ( options?: RequestInit): Promise<AgentLoad[]> => {

  return customFetch<AgentLoad[]>(getGetAgentLoadUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentLoadQueryKey = () => {
    return [
    `/api/dashboard/agent-load`
    ] as const;
    }


export const getGetAgentLoadQueryOptions = <TData = Awaited<ReturnType<typeof getAgentLoad>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentLoad>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentLoadQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentLoad>>> = ({ signal }) => getAgentLoad({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentLoad>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgentLoadQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentLoad>>>
export type GetAgentLoadQueryError = ErrorType<unknown>



export function useGetAgentLoad<TData = Awaited<ReturnType<typeof getAgentLoad>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgentLoad>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgentLoadQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetRoutingConfigUrl = () => {




  return `/api/routing`
}

export const getRoutingConfig = async ( options?: RequestInit): Promise<RoutingConfig> => {

  return customFetch<RoutingConfig>(getGetRoutingConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoutingConfigQueryKey = () => {
    return [
    `/api/routing`
    ] as const;
    }


export const getGetRoutingConfigQueryOptions = <TData = Awaited<ReturnType<typeof getRoutingConfig>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoutingConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoutingConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoutingConfig>>> = ({ signal }) => getRoutingConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoutingConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRoutingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getRoutingConfig>>>
export type GetRoutingConfigQueryError = ErrorType<unknown>



export function useGetRoutingConfig<TData = Awaited<ReturnType<typeof getRoutingConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRoutingConfig>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRoutingConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateRoutingConfigUrl = () => {




  return `/api/routing`
}

export const updateRoutingConfig = async (routingConfigUpdate: RoutingConfigUpdate, options?: RequestInit): Promise<RoutingConfig> => {

  return customFetch<RoutingConfig>(getUpdateRoutingConfigUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      routingConfigUpdate,)
  }
);}




export const getUpdateRoutingConfigMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoutingConfig>>, TError,{data: BodyType<RoutingConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRoutingConfig>>, TError,{data: BodyType<RoutingConfigUpdate>}, TContext> => {

const mutationKey = ['updateRoutingConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRoutingConfig>>, {data: BodyType<RoutingConfigUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateRoutingConfig(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoutingConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateRoutingConfig>>>
    export type UpdateRoutingConfigMutationBody = BodyType<RoutingConfigUpdate>
    export type UpdateRoutingConfigMutationError = ErrorType<unknown>

    export const useUpdateRoutingConfig = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRoutingConfig>>, TError,{data: BodyType<RoutingConfigUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRoutingConfig>>,
        TError,
        {data: BodyType<RoutingConfigUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRoutingConfigMutationOptions(options));
    }

export const getGenerateReportUrl = () => {




  return `/api/reports/generate`
}

export const generateReport = async (reportRequest: ReportRequest, options?: RequestInit): Promise<ReportResult> => {

  return customFetch<ReportResult>(getGenerateReportUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportRequest,)
  }
);}




export const getGenerateReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateReport>>, TError,{data: BodyType<ReportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateReport>>, TError,{data: BodyType<ReportRequest>}, TContext> => {

const mutationKey = ['generateReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateReport>>, {data: BodyType<ReportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  generateReport(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateReportMutationResult = NonNullable<Awaited<ReturnType<typeof generateReport>>>
    export type GenerateReportMutationBody = BodyType<ReportRequest>
    export type GenerateReportMutationError = ErrorType<unknown>

    export const useGenerateReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateReport>>, TError,{data: BodyType<ReportRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateReport>>,
        TError,
        {data: BodyType<ReportRequest>},
        TContext
      > => {
      return useMutation(getGenerateReportMutationOptions(options));
    }

